import StaticRow from "@isceco/widget-library2/basic-elements/List/StaticRow.js";

export default class DetailRow extends StaticRow {
  constructor(name, value, valueCell = undefined) {
    super(
      {name: name, value: value},
      {value: valueCell}
    )
  }
}
